var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ml-0 hidden-sm-and-down v-btn v-btn--flat v-btn--router theme--light app-toolbar__nav-link",attrs:{"flat":"","to":{ name: _vm.redirectTo }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }